module.exports = __webpack_public_path__ + "img/zjwm.96504025.png";